<template>
  <v-list-item @click='$emit("selected", item)' >
    <v-list-item-avatar v-if="item.icon || item.src" >
      <v-img v-if='item.src' :src='item.src' aspect='1:1' />
      <v-icon >{{item.icon}}</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title v-if='title' v-text='title' />
      <v-list-item-subtitle v-if='subtitle' v-text='subtitle' />
    </v-list-item-content>
    <v-list-item-action v-if='withEdit' >
      <v-btn small outlined @click='$emit("edit", item)' >Edit</v-btn>
    </v-list-item-action>
  </v-list-item>
</template>
<script>
export default {
  name: 'GenericListItem',
  props: {
    item: { type: Object, required: true },
    titleField: { type: String, default: 'title' },
    subtitleField: { type: String, default: 'subtitle' },
    withEdit: { type: Boolean, default: true }
  },
  computed: {
    title () { return this.getObjectPath(this.item, this.titleField) },
    subtitle () { return this.getObjectPath(this.item, this.subtitleField) }
  }
}
</script>
